export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const UPDATE_PROFIL = "UPDATE_PROFIL";
export const UPDATE_PASSWORD = "UPDATE_PASSWORD";
